module.exports = __webpack_public_path__ + "static/media/ic_help.aa88390b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_help.svg
// module id = 291
// module chunks = 0